// extracted by mini-css-extract-plugin
export var categories_title = "styles-module--categories_title--1m0tV";
export var categories_listwrap = "styles-module--categories_listwrap--17zDb";
export var categories_list = "styles-module--categories_list--1ehcG";